import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import useAppStore from "@/context/store";
import { getPin } from "@/services";
import useRequest from "@/utils/useReq";
import { useCallback, useRef, useState } from "react";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import PinCreatorInfo from "./PinCreatorInfo";
import PinCreatorList from "./PinCreatorList";
import styles from "./index.module.less";

export function PinCreatorModal({ pin, pinId, onOk, onCancel, ...props }) {
  const [record, setRecord] = useState(pin);
  const formRef = useRef(null);

  useRequest(
    async () => {
      if (!pinId) {
        return;
      }

      const result = await getPin({ pin_id: pinId });
      if (!result.err) {
        setRecord(result?.pin);
      } else {
        onCancel && onCancel();
      }
    },
    {
      refreshDeps: [pinId],
    }
  );

  const onSelectOk = useCallback(
    async (...args) => {
      const lastBoards = await useAppStore.getState().refreshLastBoards();
      if (lastBoards) {
        try {
          window.localStorage.setItem(
            LOCAL_STORAGE_KEY.UPDATE_LAST_BOARDS,
            JSON.stringify(lastBoards)
          );
        } catch (e) {
          console.error("设置更新最近采集失败");
        }
      }
      onOk && onOk(...args);
    },
    [onOk]
  );

  return (
    <HBModal
      className={styles.modal}
      width={720}
      footer={null}
      destroyOnClose={true}
      onCancel={onCancel}
      {...props}
    >
      <div className={styles.container} data-content-source="采集弹窗">
        <div className={styles.infoContainer}>
          <PinCreatorInfo pin={record} ref={formRef} />
        </div>
        <div className={styles.boardContainer}>
          <PinCreatorList pin={record} onOk={onSelectOk} form={formRef} />
        </div>
      </div>
    </HBModal>
  );
}

export default ModalWrap(PinCreatorModal);
